<template>
  <div>
    <div class="pagePopMask pFull" v-if="infoPop" @click="cancelImpEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="infoPop">
      <div class="w">
        <div class="tit fnt_32">学生认证</div>
        <div>
          <div class="stform">
            <a-form-model ref="realForm" :model="studentInfo">
              <a-row :gutter="16">
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item label="邮箱" :rules="{required: true, message: '请输入邮箱', trigger: 'blur' }" prop="email">
                    <a-input v-model="studentInfo.email" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item label="手机号" :rules="{required: true, message: '请输入手机号', trigger: 'blur' }" prop="phone">
                    <a-input v-model="studentInfo.phone" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item label="验证码" :rules="{required: true, message: '请输入验证码', trigger: 'blur' }" prop="code">
                    <a-input v-model="studentInfo.code" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item label="上传附件" :rules="{required: true, message: '请输入上传附件', trigger: 'blur' }" prop="url">
                    <file-upload-new v-model="studentInfo.url" accept=".pdf"/>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="confirmImpEdit">{{ globalDataArray.siteTemplateLanguage.save }}</div>
          <div class="btn btn2" @click="cancelImpEdit">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click="cancelImpEdit"></div>
      </div>
    </div>
  </div>
</template>
<script>
import FileUploadNew from '@/views/person/component/FileUploadNew.vue'
import { studentVerification } from '@/api/person/person'

export default {
  name: 'StudentAuth',
  components: { FileUploadNew },
  props: {
    infoPop: {
      type: Boolean,
      default: false
    },
    formStudent: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      studentInfo: {
        email: this.formStudent.userMail, phone: this.formStudent.userPhone, code: '', url: [], competitionId: this.formStudent.competitionId
      }
    }
  },
  watch: {
    formStudent: {
      immediate: true, // 立即触发一次
      handler(newVal) {
        this.studentInfo = {
          email: newVal.userMail || '',
          phone: newVal.userPhone || '',
          code: '',
          url: [],
          competitionId: newVal.competitionId || ''
        }
      }
    }
  },
  mounted() {
    console.log(this.studentInfo, this.formStudent, 'this.studentInfo, this.formStudent')
  },
  methods: {
    init(record) {
      this.studentInfo.email = record.userMail || ''
      this.studentInfo.phone = record.userPhone || ''
      this.studentInfo.competitionId = record.competitionId || ''
    },
    confirmImpEdit() {
      this.$refs['realForm'].validate(async (err, valid) => {
        if (err) {
          console.log(valid, this.studentInfo)
          const params = structuredClone(this.studentInfo)
          const res = await studentVerification(params)
          if (res.success) {
            this.$message.success('学生认证成功')
            this.cancelImpEdit()
          } else {
            this.$message.error(res.message)
          }
        } else {
          return false
        }
      })
    },
    cancelImpEdit() {
      this.studentInfo = {}
      this.$emit('update:infoPop', false)
    }
  }
}
</script>
